/* eslint ember/no-new-mixins:"off" */
import { computed } from '@ember/object';
import Mixin from '@ember/object/mixin';
export default Mixin.create({
  isInvalid: false,
  invalidClass: 'input-is-invalid',
  // This craziness enables mixin usages to override `invalidClass`
  classNameBindings: ['_isInvalid'],
  _isInvalid: computed('invalidClass', 'isInvalid', function () {
    return this.isInvalid ? this.invalidClass : undefined;
  })
});